import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { secrets } from '@vromo/api/constants';
import { isLocalhost } from '@vromo/utils';

// eslint-disable-next-line no-console
console.info(`Vromo Dashboard version: ${GIT_TAG} (${GIT_HASH})`);

Bugsnag.start({
    apiKey: secrets.bugsnag,
    appVersion: GIT_TAG,
    plugins: [new BugsnagPluginReact()],
    /* onError: function (event) {
        // if (event.errorClass === "GraphError") report.groupingHash = report.errorMessage
    }, */

    releaseStage: isLocalhost() ?
        'development' :
        GIT_BRANCH === 'staging' ?
            'staging' :
            'production'
});

export default Bugsnag;
